export const PATHS = {
    SIGNIN: '/',
    SIGNUP: '/signup',
    WELCOME: '/welcome',
    PROFILE: '/profile',
    CREATE_PACKAGE: '/profile/create-package',
    PACKAGE_LIST: '/profile/packages-list',
    EDIT_PACKAGE: '/profile/edit-package/:packageId',
    PACKAGE_DITAILS: '/profile/package-details/:packageId',
    CREATE_DRAW: '/profile/create-draw',
    CREATE_PROMO_DRAW: '/profile/create-promo-draw',
    PROMO_DRAW_LIST: '/profile/promo-draw-list',
    EDIT_PROMO_DRAW: '/profile/edit-promo-draw/:drawId',
    PROMO_DRAW_SIGNUP: '/promo-draw/:drawId',
    EDIT_DRAW: '/profile/edit-draw/:drawId',
    TERMS: '/profile/terms',
    PUBLIC_TERMS: '/terms',
    DRAW_LIST: '/profile/draw-list',
    DRAW_DETAILS: '/profile/draw-details/:drawId',
    DRAW_INFO: '/draw-info/:drawId',
    DRAW_INFO_LINK: '/draw-info/:drawId/:slug',
    PROMO_DRAW_LINK: '/promo-draw/:drawId/:slug', 
    PACKAGE_INFO: '/package-info/:packageId',
    TOTAL: '/total',
    DRAW_PAYMENT: '/payment/:status',
    PACKAGE_PAYMENT: '/payment/membership/:status',
    GOOGLE: '/google/success',
    OTP: '/otp',
    DRAW_USERS: '/draw-memberships/:drawId',
    PACKAGE_USERS: '/package-memberships/:packageId',
    STRIPE: '/stripe-account/:status',
    PRIVACY: '/privacy-policy',
    RESET_PASS: '/forgot-password/:email',
    CUSTOMER_VERIFICATION: '/verify-customer',
    CUSTOMER_PORTAL: '/customer-portal',
    CUSTOMER_SIGNIN: '/customer-signin',
    REWARDS_CATALOGUE: '/rewards',
    POINTS_HISTORY: '/points-history',
    PERKS: '/perks',
    CUSTOMER_GAMES: '/customer/games',
    REFUND: '/refund',
    // MANAGE_REWARDS and REDEEM_REQUESTS moved to admin-only
    
    // Admin routes
    ADMIN_LOGIN: '/admin/login',
    ADMIN_DASHBOARD: '/admin/dashboard',
    ADMIN_REWARDS: '/admin/rewards',
    ADMIN_REDEMPTION_REQUESTS: '/admin/redemption-requests',
    ADMIN_POINTS: '/admin/points',
    ADMIN_GAMES: '/admin/games'
};
